// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_tr-0";